// src/config.ts
/** Base da API: vazio em produção (same-origin), senão localhost para dev */
export function getApiBase(): string {
  const base = import.meta.env.VITE_API_URL !== undefined ? import.meta.env.VITE_API_URL : "http://localhost:3001";
  /*
   * A base NÃO leva o `/api`: todo caminho da web já começa por ele (`api.get('/api/questions')`).
   * Um `.env` de desenvolvimento com `VITE_API_URL=/api` fazia toda chamada sair como
   * `/api/api/…` e voltar 404 — a tela abria e nada carregava (medido em 11/10/2026, na web local
   * do teste do importador). O `/api` no fim da base sai aqui, e as duas formas passam a servir:
   * `/api` vira a própria origem, e `https://servidor/api` vira `https://servidor`.
   */
  return base.replace(/\/api\/?$/, "");
}